export function displayMultiSelectFieldsValue(fieldValue: { label: string; value: number }[]) {
    if (!fieldValue?.length) {
        return undefined;
    }

    return fieldValue.map((val) => val.label).join(fieldValue.length === 1 ? '' : ', ');
}
